const debtor = {
	discounts: {
		title: "Discounts",
	},

	/* ----------------------------- DOMAIN SETTINGS ---------------------------- */
	domain_settings: {
		description: `These are all or nothing settings. So one name is not and other domain name is, doesn't work.
			Customer has their own nameservers? Then they cannot manage their DNS in Portal.
			Customer wants to use our nameservers with their own name?
			
			Notify an engineer that you will do that and let them know the names (e.g. n1.customername.com and ns2.customername.com. Customername.com must be with us!)
			Create a name server group in OXXA with those names
			Wait for the engineer's approval.
			Then add that name server group in Portal and link it to the debtor.

			If you do not set anything, then by default the nameservers of Tuxis will be used, which is the desired setting.
			If you change this setting in between, it will apply to all new registrations. Old registrations will not be changed.
			So with OXXA you can also delete a nameserver group.`,
		nameserver_group: {
			title: "Custom nameserver group",
		},
		title: "Domain settings",
	},
	information: {
		description: "",
		title: "Debtor Information",
	},
	notes: {
		description: "Here are internal notes that the debtor cannot see.",
		messages: {
			success: "Internal note successfully updated!",
		},
		title: "Notes debtor",
	},
	products: {
		domain: "Domain names",
		pbs: "Tuxis PBS",
		vps: "VPSes",
	},

	/* ------------------------------ SETTINGS PAGE ----------------------------- */
	settings: {
		block_debtor: {
			block_button: "Block debtor",
			blocked: "Blocked",
			deblock_button: "Unblock debtor",
			description: "",
			title: "Block/unblock debtor",
		},
		block_dialog: "Are you sure you want to block debtor <strong>{{debtor_code}}</strong>?",
		description: "",
		messages: {
			success: "Setting changed!",
		},
		never_invoice: {
			description: "Never invoice this debtor",
			label: "Never invoice",
		},
		paid_services_disabled: {
			description: "Exclude paid services",
			label: "Paid services",
		},
		status: {
			successful_block: "Debtor successfully blocked",
			successful_unblock: "Debtor successfully unblocked",
		},
		title: "Debtor settings",
		unblock_dialog: "Are you sure you want to unblock debtor <strong>{{debtor_code}}</strong>?",
		vies: {
			button: "View VIES log",
			description: "",
			title: "VIES-API results",
		},
	},
	status: {
		create: "Debtor has been successfully added!",
		update: "Debtor has been successfully changed!",
	},
	tabs: {
		discounts: "Discounts",
		information: "Information",
		invoices: "Invoices",
		notes: "Notes",
		orders: "Orders",
		passwords: "Shared Passwords",
		products: "Products",
		relations: "Relations",
		settings: "Settings",
		users: "Users",
	},
	title: "Debtor",
};

export default debtor;
